import { BaseApplicationForLogic, Form, FormAudience } from '@features/configure-forms/form.typing';
import { LogicColumnDisplay, LogicState } from '@features/logic-builder/logic-builder.typing';
import { TypeaheadSelectOption } from '@yourcause/common/core-forms';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class FormLogicState extends BaseYcState {
  readonly reportFieldLogicColumns: LogicColumnDisplay<BaseApplicationForLogic>[];
  readonly formDetails: {
    [id: number]: Form;
  } = {};
  readonly pageOptionsMap: Record<string, TypeaheadSelectOption<string>[]> = {};
  readonly typeAudienceMap: Record<number, FormAudience> = {};
  readonly logicBuilderKeyToCompKey: Record<string, string> = {}; // Logic Builder Key -> Component Key
  readonly compKeyToLogicBuilderKey: Record<string, string> = {}; // Component Key -> Logic Builder Key
  readonly currentValidityState: LogicState<BaseApplicationForLogic, boolean>;
  readonly customValidationMap: Record<string, boolean> = {}; // Component Key -> Is Valid
  readonly finalValidationMap: Record<string, boolean> = {}; // Component Key -> Is Valid
}
